module.exports = __webpack_public_path__ + "school/img/ketijieshaoBg.34d165b7.jpg";